import script from "./PrestPopupVariantDefault.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrestPopupVariantDefault.vue?vue&type=script&lang=ts&setup=true"

import "./PrestPopupVariantDefault.vue?vue&type=style&index=0&id=f5597814&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5597814"]])

export default __exports__